import { render } from "./ceremonySignUp.vue?vue&type=template&id=1bb18428&scoped=true"
import script from "./ceremonySignUp.vue?vue&type=script&lang=js"
export * from "./ceremonySignUp.vue?vue&type=script&lang=js"

import "./ceremonySignUp.vue?vue&type=style&index=0&id=1bb18428&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb18428"]])

export default __exports__